/**
 * Liste des zones de prospection
 */

import React from 'react';
import { FaCheck, FaTrash, FaTimes } from 'react-icons/fa';
import type { ProspectionZone } from '../../types/prospectionZone';
import { ZONE_COLOR_HEX, ZONE_COLOR_LABELS } from '../../types/prospectionZone';
import './ZoneList.css';

interface ZoneListProps {
  zones: ProspectionZone[];
  selectedZoneId: string | null;
  isLoading: boolean;
  onZoneSelect: (zoneId: string | null) => void;
  onZoneToggle: (zoneId: string, isActive: boolean) => void;
  onZoneDelete: (zoneId: string) => void;
  onClose: () => void;
}

const ZoneList: React.FC<ZoneListProps> = ({
  zones,
  selectedZoneId,
  isLoading,
  onZoneSelect,
  onZoneToggle,
  onZoneDelete,
  onClose
}) => {
  if (isLoading) {
    return (
      <div className="zone-list">
        <div className="zone-list-header">
          <h3>Zones de prospection</h3>
          <button className="zone-list-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        <div className="zone-list-loading">Chargement...</div>
      </div>
    );
  }

  if (zones.length === 0) {
    return (
      <div className="zone-list">
        <div className="zone-list-header">
          <h3>Zones de prospection</h3>
          <button className="zone-list-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        <div className="zone-list-empty">
          Aucune zone de prospection.
          <br />
          Cliquez sur "Dessiner" pour créer une zone.
        </div>
      </div>
    );
  }

  return (
    <div className="zone-list">
      <div className="zone-list-header">
        <h3>Zones de prospection ({zones.length})</h3>
        <button className="zone-list-close" onClick={onClose}>
          <FaTimes />
        </button>
      </div>

      <div className="zone-list-content">
        {zones.map((zone) => (
          <div
            key={zone.id}
            className={`zone-list-item ${selectedZoneId === zone.id ? 'selected' : ''} ${
              !zone.isActive ? 'inactive' : ''
            }`}
            onClick={() => onZoneSelect(zone.id === selectedZoneId ? null : zone.id)}
          >
            <div
              className="zone-color-indicator"
              style={{ backgroundColor: ZONE_COLOR_HEX[zone.color] }}
            />

            <div className="zone-info">
              <div className="zone-name">{zone.name}</div>
              {zone.description && (
                <div className="zone-description">{zone.description}</div>
              )}
              <div className="zone-meta">
                <span className="zone-color-label">
                  {ZONE_COLOR_LABELS[zone.color]}
                </span>
                {zone.userName && (
                  <>
                    <span className="zone-meta-separator">•</span>
                    <span className="zone-user">{zone.userName}</span>
                  </>
                )}
              </div>
            </div>

            <div className="zone-actions" onClick={(e) => e.stopPropagation()}>
              <button
                className="zone-action-btn"
                onClick={() => onZoneToggle(zone.id, !zone.isActive)}
                title={zone.isActive ? 'Masquer' : 'Afficher'}
              >
                {zone.isActive ? <FaCheck /> : <FaTimes />}
              </button>

              <button
                className="zone-action-btn zone-action-delete"
                onClick={() => onZoneDelete(zone.id)}
                title="Supprimer"
              >
                <FaTrash />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ZoneList;
